<mat-form-field [appearance]="appearance" [class.list-selected]="listSelected"
    (mouseover)="listSelected=true" (mouseout)="listSelected=false">
    <mat-chip-grid #chipGrid aria-label="Category selection">
        <div class="chip-block-container">
            @for (item of selectedItems; track item) {
                <mat-chip-row [removable]="true" (click)="onChipClick(item)" (removed)="onRemove(item)">
                    @if (item.icon) {
                        <mat-icon matChipAvatar [matTooltip]="item.tooltip || ''" class="chip-avatar">{{ item.icon }}</mat-icon>
                    }
                    {{item.name}}
                    <mat-icon matChipRemove>cancel</mat-icon>
                </mat-chip-row>
            }
        </div>
        <input #searchTextInput matInput type="text" [(ngModel)]="inputValue" [placeholder]="placeholder"
            [formControl]="inputValueControl" [matAutocomplete]="auto" [matChipInputFor]="chipGrid">
    </mat-chip-grid>
    <mat-autocomplete #auto="matAutocomplete" class="mat-select-panel" [ngClass]="autocompleteClass"
        [autoActiveFirstOption]="true" (closed)="releaseFilter()">
        @for (option of data; track option; let last = $last) {
            <mat-option (onSelectionChange)="optionSelected(option)" [value]="option"
                [ngClass]="{'flavor-text-line-break' : flavorTextLineBreak }">
                @if (!isCheckbox) {
                    <span [ngClass]="{'selected-item': isSelected(option) }">
                        {{ option.name }}
                        <ng-container [ngTemplateOutlet]="flavorText" [ngTemplateOutletContext]="{data: option}"></ng-container>
                    </span>
                }
                @if (isCheckbox) {
                    <mat-checkbox (click)="$event.stopPropagation()" (change)="optionSelected(option)"
                        [checked]="isSelected(option)">{{ option.name }}</mat-checkbox>
                }
            </mat-option>
        }
        @if (data && data.length >= maxDataRows) {
            <div class="over-records">
                <span>Displaying 1st {{maxDataRows}} results.</span><br />
                <span>Keep typing to refine further.</span>
            </div>
        }
    </mat-autocomplete>
  @if (selectedItems?.length > 0) {
    <button mat-stroked-button matSuffix
            color="secondary"
            class="clear-all-btn suffix-action"
            aria-label="Clear all chips"
            (click)="$event.stopPropagation(); clearAll()">
      CLEAR ALL
    </button>
  }
</mat-form-field>
